import { Node } from '@tiptap/vue-3';

/**
 * Basic block and nestable div node extension.
 */
export const LinkBlockExtension = Node.create({
  name: 'linkBlock',
  group: 'block',
  content: 'block+',
  selectable: false,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'a',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['a', HTMLAttributes, 0];
  },
});
